var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "section-compare compare-second-ver",
      class: _vm.background,
      style: _vm.getStyle()
    },
    [
      _c("div", { staticClass: "background" }, [
        _c("div", { staticClass: "container" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "compare-form" }, [
            _c("div", { staticClass: "range-form-item-inner" }, [
              _c("div", { staticClass: "form-data-a" }, [
                _c("div", { staticClass: "box-centered" }, [
                  _c("div", { staticClass: "load-data" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.sum,
                          expression: "sum"
                        }
                      ],
                      attrs: { type: "hidden", max: "400" },
                      domProps: { value: _vm.sum },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.sum = $event.target.value
                        }
                      }
                    })
                  ])
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "ranges-slider__blck" },
                [
                  [
                    _c("range-slider", {
                      staticClass: "slider",
                      attrs: { min: 1000, max: 30000, step: 1000 },
                      model: {
                        value: _vm.electricity,
                        callback: function($$v) {
                          _vm.electricity = $$v
                        },
                        expression: "electricity"
                      }
                    })
                  ],
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "slider__scales2" },
                    _vm._l(_vm.separators, function(separator, num) {
                      return _c(
                        "div",
                        {
                          staticClass: "scale_item",
                          class: { active: null !== separator.label },
                          style: "left:" + separator.percent + "%"
                        },
                        [
                          _vm._m(1, true),
                          _vm._v(" "),
                          null !== separator.label
                            ? _c(
                                "button",
                                {
                                  staticClass: "data__blck",
                                  staticStyle: { left: "-20px" },
                                  on: {
                                    click: function($event) {
                                      return _vm.setRangeValue(num)
                                    }
                                  }
                                },
                                [_c("span", [_vm._v(_vm._s(separator.label))])]
                              )
                            : _vm._e()
                        ]
                      )
                    }),
                    0
                  )
                ],
                2
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row home-form" }, [
              _c(
                "div",
                { staticClass: "col-md-6 d-flex align-items-stretch" },
                [
                  _c("div", { staticClass: "info__blck" }, [
                    _c(
                      "div",
                      {
                        staticClass: "form-group error electricity",
                        class: { active: _vm.checkClass(_vm.electricity) }
                      },
                      [
                        _c(
                          "label",
                          {
                            staticClass: "min-min p-white",
                            on: {
                              click: function($event) {
                                return _vm.forLabelClick($event)
                              }
                            }
                          },
                          [
                            _c("img", {
                              attrs: {
                                src: require("../../../../img/icon/exclamation-sign.svg"),
                                alt: ""
                              }
                            }),
                            _vm._v(
                              "Electricity consumption/year test some text two column and more"
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model.number",
                              value: _vm.electricity,
                              expression: "electricity",
                              modifiers: { number: true }
                            }
                          ],
                          staticClass: "form-control",
                          attrs: {
                            type: "text",
                            title: "Electricity consumption/year"
                          },
                          domProps: { value: _vm.electricity },
                          on: {
                            focus: function($event) {
                              return _vm.formControlFocus($event)
                            },
                            blur: [
                              function($event) {
                                return _vm.formControlBlur($event)
                              },
                              function($event) {
                                return _vm.$forceUpdate()
                              }
                            ],
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.electricity = _vm._n($event.target.value)
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("small", [_vm._v("kWh")])
                      ]
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-md-6 d-flex align-items-stretch" },
                [
                  _c("div", { staticClass: "info__blck" }, [
                    _c("div", { staticClass: "form-group error postcode" }, [
                      _c(
                        "label",
                        {
                          staticClass: "min-min p-white",
                          on: {
                            click: function($event) {
                              return _vm.forLabelClick($event)
                            }
                          }
                        },
                        [
                          _c("img", {
                            attrs: {
                              src: require("../../../../img/icon/exclamation-sign.svg"),
                              alt: ""
                            }
                          }),
                          _vm._v("Your postcode")
                        ]
                      ),
                      _vm._v(" "),
                      _c("input", {
                        staticClass: "form-control",
                        attrs: {
                          type: "text",
                          title: "Electricity consumption/year"
                        },
                        on: {
                          focus: function($event) {
                            return _vm.formControlFocus($event)
                          },
                          blur: function($event) {
                            return _vm.formControlBlur($event)
                          }
                        }
                      }),
                      _vm._v(" "),
                      _vm._m(2)
                    ])
                  ])
                ]
              )
            ]),
            _vm._v(" "),
            _vm._m(3)
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "client-sect" }, [
            _c(
              "div",
              { staticClass: "fixed-sect" },
              [
                _vm._m(4),
                _vm._v(" "),
                _c("transition", { attrs: { name: "slide" } }, [
                  _vm.moreClient
                    ? _c("div", { staticClass: "client-list" }, [
                        _c("div", { staticClass: "client-item" }, [
                          _c("img", {
                            attrs: {
                              src: require("../../../../img/clients/bixia_ab.png"),
                              alt: ""
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "client-item" }, [
                          _c("img", {
                            attrs: {
                              src: require("../../../../img/clients/bixia_ab.png"),
                              alt: ""
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "client-item" }, [
                          _c("img", {
                            attrs: {
                              src: require("../../../../img/clients/bixia_ab.png"),
                              alt: ""
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "client-item" }, [
                          _c("img", {
                            attrs: {
                              src: require("../../../../img/clients/bixia_ab.png"),
                              alt: ""
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "client-item" }, [
                          _c("img", {
                            attrs: {
                              src: require("../../../../img/clients/e_on_energilosningar_aktiebolag.png"),
                              alt: ""
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "client-item" }, [
                          _c("img", {
                            attrs: {
                              src: require("../../../../img/clients/jonkoping_energi_ab.png"),
                              alt: ""
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "client-item" }, [
                          _c("img", {
                            attrs: {
                              src: require("../../../../img/clients/skelleftea_kraft_ab.png"),
                              alt: ""
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "client-item" }, [
                          _c("img", {
                            attrs: {
                              src: require("../../../../img/clients/1280px-Vattenfall_logo2.png"),
                              alt: ""
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "client-item" }, [
                          _c("img", {
                            attrs: {
                              src: require("../../../../img/clients/bixia_ab.png"),
                              alt: ""
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "client-item" }, [
                          _c("img", {
                            attrs: {
                              src: require("../../../../img/clients/e_on_energilosningar_aktiebolag.png"),
                              alt: ""
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "client-item" }, [
                          _c("img", {
                            attrs: {
                              src: require("../../../../img/clients/jonkoping_energi_ab.png"),
                              alt: ""
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "client-item" }, [
                          _c("img", {
                            attrs: {
                              src: require("../../../../img/clients/skelleftea_kraft_ab.png"),
                              alt: ""
                            }
                          })
                        ])
                      ])
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "openall p-center" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn__link",
                      class: { "more-client-open": _vm.moreClient },
                      on: {
                        click: function($event) {
                          return _vm.moreClientInit()
                        }
                      }
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.moreClientText) +
                          "\n                        "
                      ),
                      _c("img", {
                        attrs: {
                          src: require("../../../../img/icon/arrow-down-round-blue.svg"),
                          alt: ""
                        }
                      })
                    ]
                  )
                ])
              ],
              1
            )
          ]),
          _vm._v(" "),
          _vm._m(5)
        ])
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row justify-content-center" }, [
      _c("div", { staticClass: "title" }, [
        _c("h1", { staticClass: "h1 p-title p-center relawayBold p-black" }, [
          _vm._v("Jämför och byt elavtal")
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "Raleway med p-center" }, [
          _vm._v(
            "Vi hjälper dig hitta bästa elavtalet, bland Sveriges alla 130 elbolag som tillsammans erbjuder över 6000 elavtal"
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "item" }, [_c("span")])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "cntry_name" }, [
      _c("span", { staticClass: "marker" }, [
        _c("img", { attrs: { src: "/img/marker.svg", alt: "" } })
      ]),
      _vm._v("Stockholm")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "description" }, [
      _c("div", { staticClass: "row justify-content-center" }, [
        _c("div", { staticClass: "col-lg-7 p-center" }, [
          _c("p", { staticClass: " med mb-0" }, [
            _vm._v("You save in average: "),
            _c("b", { staticClass: "p-green" }, [_vm._v("500 kr/year")]),
            _vm._v(" by using "),
            _c("b", { staticClass: "p-green" }, [_vm._v("TecknaEl.se")])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row justify-content-center" }, [
        _c("div", { staticClass: "col-md-7 col-lg-5" }, [
          _c("div", { staticClass: "compare-btn" }, [
            _c("button", { staticClass: "btn btn-green btn-full" }, [
              _vm._v("JÄMFÖR OCH SPARA")
            ])
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "client-list" }, [
      _c("div", { staticClass: "client-item" }, [
        _c("img", {
          attrs: {
            src: require("../../../../img/clients/1280px-Vattenfall_logo2.png"),
            alt: ""
          }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "client-item" }, [
        _c("img", {
          attrs: {
            src: require("../../../../img/clients/bixia_ab.png"),
            alt: ""
          }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "client-item" }, [
        _c("img", {
          attrs: {
            src: require("../../../../img/clients/e_on_energilosningar_aktiebolag.png"),
            alt: ""
          }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "client-item" }, [
        _c("img", {
          attrs: {
            src: require("../../../../img/clients/jonkoping_energi_ab.png"),
            alt: ""
          }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "client-item" }, [
        _c("img", {
          attrs: {
            src: require("../../../../img/clients/skelleftea_kraft_ab.png"),
            alt: ""
          }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "client-item" }, [
        _c("img", {
          attrs: {
            src: require("../../../../img/clients/1280px-Vattenfall_logo2.png"),
            alt: ""
          }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "descktop__none" }, [
      _c("div", { staticClass: "garant__items" }, [
        _c("div", { staticClass: "garant-item" }, [
          _c("div", { staticClass: "img" }, [
            _c("img", { attrs: { src: "/img/header/shield.svg", alt: "" } })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "info" }, [
            _c("p", { staticClass: "min-min p-dgrey" }, [
              _vm._v("Elbyte med prisgaranti")
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "garant-item" }, [
          _c("div", { staticClass: "img" }, [
            _c("img", { attrs: { src: "/img/header/scales.svg", alt: "" } })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "info" }, [
            _c("p", { staticClass: "min-min p-dgrey" }, [
              _vm._v("Jämför och byt gratis ")
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "garant-item" }, [
          _c("div", { staticClass: "img" }, [
            _c("img", { attrs: { src: "/img/header/calendar.svg", alt: "" } })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "info" }, [
            _c("p", { staticClass: "min-min p-dgrey" }, [
              _vm._v("14 dagars ångerrätt")
            ])
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }